// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".site__footer{bottom:0;left:0;padding-bottom:15px;position:absolute;width:100%;text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
